'use client';

import React, { useCallback } from 'react';
import type { Endpoint } from '@context/openapi/types';
import { ApiDocumentationLink } from '@components/_components/ui/ApiDocumentationLink';

interface EndpointSelectionBarProps {
  currentEndpoint: Endpoint;
  resource: string;
  apiEndpoint: Endpoint;
}

export const EndpointSelectionBar: React.FC<EndpointSelectionBarProps> = ({
  currentEndpoint,
  resource,
  apiEndpoint,
}) => {
  const openSearchModal = useCallback(() => {
    const isMac = /(Mac|iPhone|iPod|iPad)/i.test(navigator.userAgent);
    document.dispatchEvent(
      new KeyboardEvent('keydown', {
        key: 'k',
        code: 'KeyK',
        metaKey: isMac,
        ctrlKey: !isMac,
        bubbles: true,
      })
    );
  }, []);

  return (
    <div className="px-4 py-2 space-y-2">
      <div className="flex items-center justify-start gap-2">
        <h1 className="text-[#012A38] text-lg font-semibold tracking-tight">
          {currentEndpoint.name}
        </h1>

        <div className="flex items-center gap-2 text-[12px]">
          [
          <button
            type="button"
            onClick={openSearchModal}
            className={
              'text-blue-600 hover:text-blue-800 underline  text-[12px] font-medium inline-flex items-center gap-1 transition-colors duration-200'
            }
          >
            <span>Switch Endpoint</span>
          </button>
          <span className="text-gray-300">|</span>
          <ApiDocumentationLink resource={resource} apiEndpoint={apiEndpoint} />
          ]
        </div>
      </div>

      <div className="flex items-center gap-2">
        <span className="bg-[#012A38] text-white font-semibold uppercase text-[10px] leading-none rounded-full px-3 py-1.5">
          {currentEndpoint.method}
        </span>
        <span className="text-[#012A3899] text-sm tracking-tight">
          {currentEndpoint.url}
        </span>
      </div>
    </div>
  );
};
